












































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import echarts from "echarts";
import Empty from "@/components/empty.vue";
import {
  EditQA,
  GetKnowledgeWendaList,
  SearchZhishidian,
  GetZhishidianDetail,
  GetTuijian,
  GetChapterResource,
  GetChapter,
} from "@/request/common";
import QaCell from "@/components/qa/qa-cell.vue";
import TiwenDialog from "../components/tiwenDialog.vue";
@Component({
  components: {
    Empty,
    QaCell,
    TiwenDialog,
  },
})
export default class Name extends Vue {
  private curNode: any = {};
  private searchText: any = {};
  private tuijianData: any = [];
  private ifShowTupu: any = false;
  private ifShowMore: any = false;
  private searchOptions: any = [];
  private tupuData: any = {
    categories: [],
    links: [],
    nodes: [],
  };
  private colors: any = [
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
  ];
  private rightData: any = {
    原文: "",
    图片: [],
    课件: [],
    视频: [],
    讨论: [],
  };
  private ifShowTiwen: any = false;
  private isTouchDevice: boolean = false;
  private get user() {
    return this.$store.state.user;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private selectTuijian(item: any) {
    this.searchText = item;
    this.getTupuData();
  }
  private search() {
    this.curNode = {};
    this.getTupuData();
  }
  private openTiwen() {
    this.ifShowTiwen = true;
  }
  private addWenti(e: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    e.chapter_id = this.curNode.chapter_id;
    if (!e.asker_id) {
      e.asker_id = this.user.user_id;
    }
    if (!e.banji_id) {
      e.banji_id = this.user["所属班级"].banji_id;
    }
    EditQA(this, e, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("提问成功");
        this.ifShowTiwen = false;
        this.getKnoledge();
      })
      .catch(() => {
        loading.close();
      });
  }
  private openBigTupu() {
    this.ifShowTupu = true;
    this.drawTupu2();
  }
  private exit() {
    this.ifShowTupu = false;
  }
  private remoteMethod(e: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        search: e,
      },
    };
    SearchZhishidian(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.searchOptions = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private getTupuData() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          chapter_id: this.searchText.chapter_id,
        },
      };
      GetZhishidianDetail(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.curNode = {};
          this.rightData = { 原文: "", 图片: [], 课件: [], 视频: [], 讨论: [] };
          let categories: any = [];
          res.categories.forEach((ele: any) => {
            categories.push({ name: ele });
          });
          res.categories = categories;
          const data = res;
          data.nodes.forEach((ele: any, index: any) => {
            if (ele.type === "目标") {
              ele.symbol = "roundRect";
              ele.symbolSize = 25;
            } else if (ele.type === "实体") {
              ele.symbolSize = 20;
            } else {
              ele.symbolSize = 1;
            }
          });
          this.tupuData = data;
          this.drawTupu1();
          resolve(true);
        })
        .catch(() => {
          loading.close();
          reject();
        });
    });
  }
  private chartInstance1: any = null;
  private chartInstance2: any = null;

  private zoomIn() {
    if (this.chartInstance1) {
      this.chartInstance1.dispatchAction({
        type: "dataZoom",
        dataZoomIndex: 0,
        start: 0,
        end: 100,
      });
      // 放大1.2倍
      const option = this.chartInstance1.getOption();
      const currentZoom = option.series[0].zoom || 1;
      this.chartInstance1.setOption({
        series: [
          {
            zoom: currentZoom * 1.2,
          },
        ],
      });
    }
  }

  private zoomOut() {
    if (this.chartInstance1) {
      // 缩小到0.8倍
      const option = this.chartInstance1.getOption();
      const currentZoom = option.series[0].zoom || 1;
      this.chartInstance1.setOption({
        series: [
          {
            zoom: currentZoom * 0.8,
          },
        ],
      });
    }
  }

  private resetZoom() {
    if (this.chartInstance1) {
      this.chartInstance1.setOption({
        series: [
          {
            zoom: 1.5,
          },
        ],
      });
    }
  }

  private bigZoomIn() {
    if (this.chartInstance2) {
      const option = this.chartInstance2.getOption();
      const currentZoom = option.series[0].zoom || 1;
      this.chartInstance2.setOption({
        series: [
          {
            zoom: currentZoom * 1.2,
          },
        ],
      });
    }
  }

  private bigZoomOut() {
    if (this.chartInstance2) {
      const option = this.chartInstance2.getOption();
      const currentZoom = option.series[0].zoom || 1;
      this.chartInstance2.setOption({
        series: [
          {
            zoom: currentZoom * 0.8,
          },
        ],
      });
    }
  }

  private bigResetZoom() {
    if (this.chartInstance2) {
      this.chartInstance2.setOption({
        series: [
          {
            zoom: 1.5,
          },
        ],
      });
    }
  }

  private closeBigTupu() {
    this.ifShowTupu = false;
  }

  private drawTupu1() {
    this.$nextTick(() => {
      this.chartInstance1 = echarts.init(this.$refs.tupu as HTMLCanvasElement);
      const options: any = {
        color: this.colors,
        title: {
          text: "",
          subtext: "",
          top: "bottom",
          left: "right",
        },
        tooltip: {},
        legend: [
          {
            show: false,
            // selectedMode: 'single',
            data: this.tupuData.categories.map(function (a: any) {
              return a.name;
            }),
          },
        ],
        animationDuration: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            name: "",
            type: "graph",
            layout: "force",
            data: this.tupuData.nodes,
            links: this.tupuData.links,
            categories: this.tupuData.categories,
            zoom: 1.5,
            roam: this.getRoamConfig(),
            label: {
              show: true,
              position: "inside",
              formatter: "{b}",
            },
            edgeLabel: {
              show: false,
              formatter: (res: any) => {
                return res.data.name;
              },
            },
            edgeSymbol: ["", "arrow"],
            itemStyle: {
              normal: {
                color: (params: any) => {
                  let color: any = "";
                  if (params.data.type == "实体") {
                    color = "#5470C6";
                  } else {
                    color = "red";
                  }
                  return color;
                },
              },
            },
            lineStyle: {
              color: "#666",
              width: 3,
              curveness: 0.1,
            },
            emphasis: {
              show: false,
              focus: "adjacency",
              lineStyle: {
                width: 6,
              },
            },
          },
        ],
      };
      this.chartInstance1.setOption(options);
      this.chartInstance1.resize();
      // 点击事件
      this.chartInstance1.off("click");
      this.chartInstance1.on("click", (p: any) => {
        this.curNode = p.data;
        this.curNode.chapter_id = p.data.id;
        console.log(this.curNode);
        this.$forceUpdate();
        this.getData();
      });
    });
  }

  private drawTupu2() {
    this.$nextTick(() => {
      this.chartInstance2 = echarts.init(this.$refs.tupu2 as HTMLCanvasElement);
      const options: any = {
        color: this.colors,
        title: {
          text: "",
          subtext: "",
          top: "bottom",
          left: "right",
        },
        tooltip: {},
        legend: [
          {
            // selectedMode: 'single',
            data: this.tupuData.categories.map(function (a: any) {
              return a.name;
            }),
          },
        ],
        animationDuration: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            name: "",
            type: "graph",
            layout: "force",
            data: this.tupuData.nodes,
            links: this.tupuData.links,
            categories: this.tupuData.categories,
            zoom: 1.5,
            roam: this.getRoamConfig(),
            label: {
              show: true,
              position: "inside",
              formatter: "{b}",
            },
            edgeLabel: {
              show: false,
              formatter: (res: any) => {
                return res.data.name;
              },
            },
            edgeSymbol: ["", "arrow"],
            itemStyle: {
              normal: {
                color: (params: any) => {
                  let color: any = "";
                  if (params.data.type == "实体") {
                    color = "#5470C6";
                  } else {
                    color = "red";
                  }
                  return color;
                },
              },
            },
            lineStyle: {
              color: "#666",
              width: 3,
              curveness: 0.1,
            },
            emphasis: {
              show: false,
              focus: "adjacency",
              lineStyle: {
                width: 6,
              },
            },
          },
        ],
      };
      this.chartInstance2.setOption(options);
      this.chartInstance2.resize();
    });
  }

  private getData() {
    this.getKnoledge();
    this.getYuanwen();
    this.getResources("图片");
    this.getResources("课件");
    this.getResources("视频");
  }

  private getYuanwen() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        chapter_id: this.curNode.chapter_id,
      },
    };
    GetChapter(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.rightData["原文"] = res.content;
      })
      .catch(() => {
        loading.close();
      });
  }

  private getResources(val: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        chapter_id: this.curNode.chapter_id,
        类别: val,
      },
    };
    GetChapterResource(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.rightData[val] = res;
      })
      .catch(() => {
        loading.close();
      });
  }

  private getKnoledge() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        chapter_id: this.curNode.chapter_id,
        banji_id: this.user["所属班级"].banji_id,
      },
    };
    GetKnowledgeWendaList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.rightData["讨论"] = res.data;
      })
      .catch(() => {
        loading.close();
      });
  }

  private preview(url: any) {
    window.open(url);
  }

  private getTuijian() {
    return new Promise((resolve, reject) => {
      GetTuijian(this)
        .then((res: any) => {
          this.tuijianData = res;
          if (res.length > 0) {
            this.searchText = res[0];
            this.getTupuData().then(() => {
              resolve(true);
            });
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  private mounted() {
    window.addEventListener("resize", this.handleResize);
    // 检测是否为触摸设备
    this.isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    this.remoteMethod("");
    if (this.$route.query.data) {
      this.getTuijian().then(() => {
        this.curNode = JSON.parse(this.$route.query.data as any);
        this.getData();
      });
    } else {
      this.getTuijian();
    }
  }

  private beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  private handleResize() {
    if (this.chartInstance1) this.chartInstance1.resize();
    if (this.chartInstance2) this.chartInstance2.resize();
  }

  private getRoamConfig() {
    if (this.isTouchDevice) {
      // 触摸设备的配置
      return {
        move: true,
        zoom: true,
        scale: true,
        mouseWheel: false, // 触摸设备禁用鼠标滚轮
        touch: true,
      };
    }
    // 非触摸设备使用默认配置
    return true;
  }
}
